/** PipelineIntelligenceRoute — skin-aware switcher for /pipeline-intelligence. */
import { useUISkin } from "@/data/UISkinContext";
import PipelineIntelligence from "./PipelineIntelligence";
import PipelineIntelligenceCockpit from "./PipelineIntelligenceCockpit";

export default function PipelineIntelligenceRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <PipelineIntelligenceCockpit />;
  return <PipelineIntelligence />;
}
